import axios from "axios"
import SessionManager from "@/utils/session-manager"
// const BASE_URI = '/api/v1'
/* eslint-disable */  
const BASE_URI_GO = process.env.API_GO_URL + '/api/v1'
const OPEN_URI_GO = process.env.API_GO_URL

export default class ApiClientGo {
  static request(options={}) { 
    return axios(this._prepareOptions(options))
  }

  static request_GO(options={}) {
    return axios(this._prepareOptions_GO(options))
  }

  static get(url, options={}) {
    return this.request(Object.assign(options,{url: url, method: "get"}))
  }
  static get_GO(url, options={}) {
    return this.request_GO(Object.assign(options,{url: url, method: "get"}))
  }

  static post(url, options={}) {
    return this.request(Object.assign(options,{url: url, method: "post"}))
  }

  static put(url, options={}) {
    return this.request(Object.assign(options,{url: url, method: "put"}))
  }

  static put_GO(url, options={}) {
    return this.request_GO(Object.assign(options,{url: url, method: "put"}))
  }

  static delete(url, options={}) {
    return this.request(Object.assign(options,{url: url, method: "delete"}))
  }

  static _prepareOptions(givenOptions) {
    if(!givenOptions.headers) { givenOptions.headers = {} }
    if(!givenOptions.headers["Accept"]) {
      givenOptions.headers["Accept"] = 'application/json'
    }
    if(!givenOptions.headers["Content-Type"]) {
      givenOptions.headers["Content-Type"] = 'application/json'
    }

    givenOptions.url = `${OPEN_URI_GO}/${givenOptions.url}`
    return givenOptions
  }

  static _prepareOptions_GO(givenOptions) {
    if(!givenOptions.headers) { givenOptions.headers = {} }
    if(!givenOptions.headers["Accept"]) {
      givenOptions.headers["Accept"] = 'application/json'
    }
    if(!givenOptions.headers["Content-Type"]) {
      givenOptions.headers["Content-Type"] = 'application/json'
    }

    const accessToken = SessionManager.getAuthToken()

    if(accessToken) {
      givenOptions.headers = Object.assign(givenOptions.headers, {
        Authorization: `Bearer ${accessToken}`
      })
    }

    givenOptions.data = JSON.stringify(givenOptions.data)
    givenOptions.url = `${BASE_URI_GO}/${givenOptions.url}`
    return givenOptions
  }

  static gerarEstatistica(id) {
    return this.request_GO({
      url: `GetEstatisticas/${id}`,
      method: "GET",
    })
    .then((response) => {
        return response 
    })
  }

  static gerarEstatisticaPlataformaInvestidores(tipo) {
    return this.request_GO({
      url: `GetEstatisticasPlataformaInvestidores/${tipo}`,
      method: "GET",
      data: tipo,
    })
    .then((response) => {
      return response
    })
  }

  static getInfoDarf(idTransacao) {
    return this.request_GO({
      url: `GetInfoDarf/${idTransacao}`,
      method: "GET"
    })
    .then((response) => {
      return response
    })
  }

  static getInforme() {
    return this.request_GO({
      url: `investidor/informe`,
      method: "GET"
    })
    .then((response) => {
      return response
    })
  }

  static atualizarContaBancaria(documento) {
    return this.request_GO({
      url: `alterarConta/${documento}`,
      method: "GET"
    })
    .then((response) => {
      return response
    })
  }

  static tabelaValoresInvestidores(solicitacaoId, reservaId) {
    return this.request_GO({
      url: `tabela/price/alongamento/${solicitacaoId}/${reservaId}`,
      method: "GET"
    })
    .then((response) => {
      return response
    })
  }

  static oportunidadePorId(id) {
    return this.request_GO({
      url: `solicitacoes/${id}`,
      method: "GET"
    })
    .then((response) => {
      return response
    })
  }

  static ListarOportunidades(pagina, scores) {
    return this.request_GO({
      url: `solicitacoes/listar/${pagina}/${scores}`,
      method: "GET"
    })
    .then((response) => {
      return response.data
    })
  }

  static getLoanRequest(solicitacaoId) {
    return this.request_GO({
      url: `solicitacoes/detalhes/${solicitacaoId}`,
      method: "GET"
    })
    .then((response) => {
      let loanRequest = Object.assign({}, response.data.Solicitacao)

      if(loanRequest.Empresa) {
        if(loanRequest.Empresa.DataFundacao) {
          loanRequest.Empresa.DataFundacao = new Date(loanRequest.Empresa.DataFundacao)
        }
        if(loanRequest.Empresa.DataConsultaEndividamento) {
          loanRequest.Empresa.DataConsultaEndividamento = new Date(loanRequest.Empresa.DataConsultaEndividamento)
        }
      }
      if(loanRequest.InicioCaptacao) {
        loanRequest.InicioCaptacao = new Date(loanRequest.InicioCaptacao)
      }
      if(loanRequest.FimCaptacao) {
        // loanRequest.FimCaptacaoText = loanRequest.FimCaptacao;
        loanRequest.FimCaptacao = new Date(loanRequest.FimCaptacao)
      }
      return loanRequest
    })
  }

  static ListarAntecipados(pagina, scores) {
    return this.request_GO({
      url: `solicitacoes/listar/${pagina}/score/${scores}/produto/empres`,
      method: "GET"
    })
    .then((response) => {
      console.log(response)
      return response.data
    })
  }

  static sign_up({name, email, password, CodigoConvidado, tipo=null}) {
    return axios(
      {
        url: OPEN_URI_GO + `/sign_up`,
        method: "POST",
        headers:{
          provider: "iouu",
          token: "e3eb9b7ab88facd2a7ec805a3bbcee2aff81733b",
        },
        data: {name, email, password, CodigoConvidado, tipo}
      })
  }

  static sign_in({email, password}) {
    const formData = new FormData();
    formData.append('email',email)
    formData.append('password',password)
    return axios(
      {
        url: OPEN_URI_GO + `/sign_in`,
        method: "POST",
        headers:{
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      })
  }

  static CheckCampanhaReinvestimentoMultiplo(valor) {
    return this.request_GO({
      url: `investidor/valida-multiplo-campanha/${valor}`,
      method: "GET"
    })
    .then((response) => {
      return response.data
    })
  }

}


// WEBPACK FOOTER //
// ./src/utils/api-client-go.js